import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'

import reportsServices from '../reportsServices';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import PendingCounterByGroup from '../components/PendingCounterByGroup';
import GroupPendencyTotal from '../components/GroupPendencyTotal';
import GroupPendencyChart from '../components/GroupPendencyChart';



function GrievancePendingReportByGroupPage() {

    const [supervisorList,setSupervisorList] = useState(null);
    const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);

    const getPendingReport = () => {
        reportsServices.getPendingByGroup().then(res=>{
            setSupervisorList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getPendingReport()
    },[])

   
    

    return (
        <AppLayout>
            <div className='container-fluid'>
                    <div className='row mb-3'>
                        <div className='col-md-12'>
                            <div class="p-2 bg-dark text-center text-white rounded">
                                <h3 className='mb-0' >Supervisor Pendency</h3>
                            </div>
                        </div>
                    </div> 
                    {supervisorList &&
                        <GroupPendencyTotal supervisorList={supervisorList} getMasterLabel={getMasterLabel} />
                    }
                    {supervisorList &&
                        <div className='row'>
                            <div className='col-md-3'>
                                <GroupPendencyChart supervisorList={supervisorList} getMasterLabel={getMasterLabel} />
                            </div>
                            <div className='col-md-9'>
                                { supervisorList.map(supervisor=>
                                    masters && supervisor.assignedGrievanceType !==null && 
                                    <PendingCounterByGroup 
                                        reportData={supervisor.grievanceList} 
                                        assignedGrievanceType={supervisor.assignedGrievanceType.split(",").map(Number)}
                                        masters={masters}
                                        supervisorName={supervisor.firstName+" "+supervisor.lastName} 
                                        getMasterLabel={getMasterLabel}
                                    />
                                )}
                            </div>
                        </div>
                    }

                    
            </div>
        </AppLayout>
    )
}

export default GrievancePendingReportByGroupPage